import React, { useEffect, useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

const EBStatus = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Set initial customer data from the Redux store
  const [customerId] = useState(authState.user._id); 
  const [customerCode] = useState(authState.user.think5whyscode); 
  const [customerName] = useState(authState.user.name); 
  const [customerEmail] = useState(authState.user.email); 
  const [customerPhone] = useState(''); 
  
  // Set initial payment data
  const [paymentData, setPaymentData] = useState({
    txnid: '',
    status: '',
    amount: '',
  });

  useEffect(() => {
    // Function to extract and parse query parameters
    const getQueryParams = () => {
      const params = new URLSearchParams(location.search);
      const txnid = params.get('txnid');
      const status = params.get('status');
      const amount = params.get('amount');
      
      return { txnid, status, amount };
    };

    // Extract parameters from the URL
    const params = getQueryParams();
    // console.log('Extracted Params:', params); // Debugging log

    // If parameters are found, update the state
    if (params.txnid && params.status && params.amount) {
      setPaymentData({
        txnid: params.txnid,
        status: params.status,
        amount: params.amount,
      });
    } else {
      // console.log('Missing query parameters!'); // Debugging log for missing parameters
    }
  }, [location.search]);  // Dependency array, runs whenever location.search changes

  const handleGotoWallet = () => {
    navigate("/wallet-mywallet");
  };

  return (
    <MainLayout>
      <div className="bg-gray-600 text-center py-8 px-4">
        <h2 className="text-xl font-bold mb-4">
          {paymentData.status === 'success' ? 'Payment Successful!' : 'Payment Failed!'}
        </h2>
        <p className="text-lg">Transaction ID: {paymentData.txnid || 'N/A'}</p>
        <p className="text-lg">Status: {paymentData.status || 'N/A'}</p>
        <p className="text-lg">Amount: {paymentData.amount || 'N/A'}</p>
      </div>
      <div>
        <button
          onClick={handleGotoWallet}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
        >
          My Think5Whys Purse / Wallet
        </button>
      </div>
    </MainLayout>
  );
};

export default EBStatus;
